import { useState } from 'react';
import { useSendAgentMessage } from './lineApi';
import { AttachCustomerFileModal } from './AttachCustomerFileModal';

interface Props {
  contactId: number;
  disabled: boolean;
  disabledReason: string | undefined;
  /** 是否已綁定客戶 — 影響「附件」按鈕是否可用 */
  canAttach: boolean;
}

export function ComposerBox({ contactId, disabled, disabledReason, canAttach }: Props): JSX.Element {
  const [text, setText] = useState('');
  const [attachOpen, setAttachOpen] = useState(false);
  const sendMutation = useSendAgentMessage();

  const onSend = (): void => {
    const trimmed = text.trim();
    if (!trimmed) return;
    sendMutation.mutate(
      { contactId, text: trimmed },
      {
        onSuccess: () => {
          setText('');
        },
      },
    );
  };

  return (
    <div className="border-t bg-white p-2">
      {disabled ? (
        <div className="text-xs text-slate-500 px-1 py-1">{disabledReason ?? '無法回覆'}</div>
      ) : null}
      <div className="flex gap-2 items-end">
        <button
          type="button"
          disabled={disabled || !canAttach}
          onClick={() => setAttachOpen(true)}
          title={
            disabled
              ? '請先接管對話'
              : !canAttach
                ? '請先綁定客戶後才能附加檔案'
                : '從客戶訪談附件中挑一份送出'
          }
          className="border rounded px-3 py-2 text-sm text-slate-700 hover:bg-slate-100 disabled:opacity-40 disabled:cursor-not-allowed"
        >
          📎 附件
        </button>
        <textarea
          value={text}
          onChange={(e) => setText(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter' && (e.metaKey || e.ctrlKey)) {
              e.preventDefault();
              onSend();
            }
          }}
          disabled={disabled || sendMutation.isPending}
          rows={2}
          placeholder={disabled ? '' : '輸入訊息(Ctrl/⌘+Enter 送出)'}
          className="flex-1 border rounded px-2 py-1.5 text-sm focus:outline-none focus:ring-2 focus:ring-blue-400 disabled:bg-slate-100"
        />
        <button
          type="button"
          disabled={disabled || sendMutation.isPending || !text.trim()}
          onClick={onSend}
          className="bg-blue-600 text-white rounded px-4 py-2 text-sm hover:bg-blue-700 disabled:opacity-50"
        >
          {sendMutation.isPending ? '送出中…' : '送出'}
        </button>
      </div>
      {sendMutation.isError ? (
        <div role="alert" className="text-xs text-red-600 pt-1">
          送出失敗:{sendMutation.error instanceof Error ? sendMutation.error.message : '未知錯誤'}
        </div>
      ) : null}

      <AttachCustomerFileModal
        open={attachOpen}
        contactId={contactId}
        onClose={() => setAttachOpen(false)}
      />
    </div>
  );
}
